import { Link } from 'react-router-dom'
import { ArrowUpRight, Activity, Search, Network } from 'lucide-react'
import { KnowledgeFrame } from '../components/KnowledgeNav'
import { KnowledgeVisualOverview } from '../components/KnowledgeVisualOverview'
import { DomainAgenda } from '../components/DomainAgenda'
import { GardenDashboard } from '../components/GardenDashboard'

export function KnowledgePage() {
  return (
    <KnowledgeFrame
      title="Knowledge garden"
      description="Follow the garden’s progress, explore shared ideas, and see how knowledge reaches discovery."
    >
      <KnowledgeVisualOverview />
      <GardenDashboard view="pipeline" />
      <DomainAgenda compact />
      <GardenDashboard view="preview" />
      <section aria-label="Explore Knowledge in detail" className="grid gap-4 md:grid-cols-3">
        {[
          {
            to: 'operations',
            title: 'Operations & resolutions',
            detail: 'Follow jobs, decisions and what has reached the graph.',
            icon: Activity,
          },
          {
            to: 'domains',
            title: 'Research domains',
            detail: 'Browse the full agenda, evidence and review history.',
            icon: Network,
          },
          {
            to: 'concepts',
            title: 'Concept catalogue',
            detail: 'Search every concept, alias, source and artwork connection.',
            icon: Search,
          },
        ].map(({ to, title, detail, icon: Icon }) => (
          <Link
            key={to}
            to={`/app/knowledge/${to}`}
            className="group rounded-xl border bg-card p-5 transition-colors hover:border-arthaus-gold/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-arthaus-gold"
          >
            <div className="flex items-center justify-between">
              <Icon className="h-5 w-5 text-arthaus-gold" />
              <ArrowUpRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 motion-reduce:transform-none" />
            </div>
            <h2 className="mt-4 font-serif text-xl">{title}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{detail}</p>
          </Link>
        ))}
      </section>
    </KnowledgeFrame>
  )
}
